import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { commonTranslationFallback } from '../language/language-preferences';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(
    private snackBar: MatSnackBar
  ) { }

  success(message: string) {
    this.snackBar.open(message, 'X', {
      duration: 5000,
      panelClass: 'alert-success',
      verticalPosition: 'bottom',
    });
  }

  error(message: string) {
    if (message == '[object Object]') {
      this.snackBar.open(commonTranslationFallback('genericError'), 'X', {
        duration: 30000,
        panelClass: 'alert-danger',
        verticalPosition: 'bottom',
      });
    } else {
      this.snackBar.open(message, 'X', {
        duration: 30000,
        panelClass: 'alert-danger',
        verticalPosition: 'bottom',
      });
    }
  }
}
